import { useState } from 'react';
import { X } from 'lucide-react';
import { COMPANY_MAILBOXES, type CompanyMailbox } from '../../lib/company-mail';
import { commitEmails } from '../../lib/email-addresses';
import { Field, Input, Select, TextArea } from '../ui/Input';

export function EmailFields({ from, to, cc, subject, body, onFrom, onTo, onCc, onSubject, onBody }: {
  from: CompanyMailbox;
  to: string[];
  cc: string[];
  subject: string;
  body: string;
  onFrom: (next: CompanyMailbox) => void;
  onTo: (next: string[]) => void;
  onCc: (next: string[]) => void;
  onSubject: (next: string) => void;
  onBody: (next: string) => void;
}) {
  const [showCc, setShowCc] = useState(cc.length > 0);
  return (
    <div className="space-y-3">
      <Field label="From">
        <Select value={from} onChange={(event) => onFrom(event.target.value as CompanyMailbox)}>
          {COMPANY_MAILBOXES.map((mailbox) => <option key={mailbox} value={mailbox}>{mailbox}</option>)}
        </Select>
      </Field>
      <p className="text-xs text-[var(--bo-faint)]">Bcc is office@maxiron.com.</p>
      <Field label="To"><AddressTags values={to} placeholder="Add an email" onChange={onTo} /></Field>
      {showCc ? (
        <Field label="Cc"><AddressTags values={cc} placeholder="Add a Cc email" onChange={onCc} /></Field>
      ) : (
        <button type="button" className="text-sm text-[var(--bo-link)]" onClick={() => setShowCc(true)}>Add cc</button>
      )}
      <Field label="Subject"><Input value={subject} onChange={(event) => onSubject(event.target.value)} /></Field>
      <Field label="Message"><TextArea value={body} onChange={(event) => onBody(event.target.value)} /></Field>
    </div>
  );
}

function AddressTags({ values, placeholder, onChange }: { values: string[]; placeholder: string; onChange: (next: string[]) => void }) {
  const [draft, setDraft] = useState('');
  function apply(finish: boolean) {
    const result = commitEmails(values, draft, finish);
    if (result.values.length !== values.length) onChange(result.values);
    setDraft(result.rest);
  }
  return (
    <div className="flex min-h-10 flex-wrap items-center gap-2 rounded-lg border border-[var(--bo-border)] bg-[var(--bo-canvas)] px-2 py-1">
      {values.map((email) => (
        <span key={email} className="inline-flex items-center gap-1 rounded-md bg-[var(--bo-pill)] px-2 py-1 text-sm">
          {email}
          <button type="button" aria-label={`Remove ${email}`} className="text-[var(--bo-muted)]" onClick={() => onChange(values.filter((item) => item !== email))}><X className="h-3 w-3" /></button>
        </span>
      ))}
      <input
        className="h-8 min-w-40 flex-1 bg-transparent text-sm outline-none"
        placeholder={values.length ? '' : placeholder}
        value={draft}
        onChange={(event) => {
          const next = event.target.value;
          if (/[,;\n]/.test(next)) {
            const result = commitEmails(values, next, false);
            if (result.values.length !== values.length) onChange(result.values);
            setDraft(result.rest);
            return;
          }
          setDraft(next);
        }}
        onBlur={() => apply(true)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') { event.preventDefault(); apply(true); }
          if (event.key === 'Backspace' && !draft && values.length) onChange(values.slice(0, -1));
        }}
      />
    </div>
  );
}
